var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('div',{staticClass:"container"},[_c('static-page')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }